import { useIntl } from 'react-intl';
import React from 'react';
import { computeRegulationLabel } from '../../../util';
import { RadioInput } from './RadioInput';
import styles from './ReportEventFormRadios.module.scss';

const radioClassNames = styles.radioInput;

export const ReportEventFormRadios = (props: {
    country: string;
    userCountry: string;
}) => {
    const { country, userCountry } = props;
    const intl = useIntl();
    const regulationLabel = computeRegulationLabel(country, userCountry);
    const showOtherIllegalContent = regulationLabel !== '';
    const otherIllegalContent = intl.formatMessage({
        id: 'Other Illegal Content',
        defaultMessage: 'Other Illegal Content',
    });
    const requestRefund = intl.formatMessage({
        id: 'Request a Refund',
        defaultMessage: 'Request a Refund',
    });
    const askQuestion = intl.formatMessage({
        id: 'Ask a question or give feedback about the event',
        defaultMessage: 'Ask a question or give feedback about the event',
    });
    const eventNotHappened = intl.formatMessage({
        id: 'Event did not happen or was not as described',
        defaultMessage: 'Event did not happen or was not as described',
    });
    const spamContent = intl.formatMessage({
        id: 'Spam or misleading content',
        defaultMessage: 'Spam or misleading content',
    });
    const unauthorizedEvent = intl.formatMessage({
        id: 'Event not authorised to sell tickets or report invalid tickets',
        defaultMessage: 'Event not authorised to sell tickets or report invalid tickets',
    });
    const paymentOutside = intl.formatMessage({
        id: 'Payment required outside Eventbrite',
        defaultMessage: 'Payment required outside Eventbrite',
    });
    const harmfulContent = intl.formatMessage({
        id: 'Harmful Content',
        defaultMessage: 'Harmful Content',
    });
    const regulatedContent = intl.formatMessage({
        id: 'Regulated Content or Activities',
        defaultMessage: 'Regulated Content or Activities',
    });
    const explicitContent = intl.formatMessage({
        id: 'Sexually Explicit Content',
        defaultMessage: 'Sexually Explicit Content',
    });
    const hatefulContent = intl.formatMessage({
        id: 'Hateful Content',
        defaultMessage: 'Hateful Content',
    });
    const violenceExtremism = intl.formatMessage({
        id: 'Violence or Extremism',
        defaultMessage: 'Violence or Extremism',
    });
    const copyrightInfringement = intl.formatMessage({
        id: 'Copyright or Trademark Infringement',
        defaultMessage: 'Copyright or Trademark Infringement',
    });
    const radioInputRender = showOtherIllegalContent && (
        <RadioInput
            reason="reason_other_illegal_eu_dsa"
            containerClassNames={radioClassNames}
        >
            {otherIllegalContent}
        </RadioInput>
    );
    return (
        <div className={styles.radioContainer}>
            <RadioInput
                reason="reason_refund"
                containerClassNames={radioClassNames}
            >
                {requestRefund}
            </RadioInput>
            <RadioInput
                reason="reason_feedback"
                containerClassNames={radioClassNames}
            >
                {askQuestion}
            </RadioInput>
            <RadioInput
                reason="reason_canceled_event"
                containerClassNames={radioClassNames}
            >
                {eventNotHappened}
            </RadioInput>
            <RadioInput
                reason="reason_spam_behavior"
                containerClassNames={radioClassNames}
            >
                {spamContent}
            </RadioInput>
            <RadioInput
                reason="reason_unauthorized_event"
                containerClassNames={radioClassNames}
            >
                {unauthorizedEvent}
            </RadioInput>
            <RadioInput
                reason="reason_payment_outside"
                containerClassNames={radioClassNames}
            >
                {paymentOutside}
            </RadioInput>
            <RadioInput
                reason="reason_harmful"
                containerClassNames={radioClassNames}
            >
                {harmfulContent}
            </RadioInput>
            <RadioInput
                reason="reason_offensive_content"
                containerClassNames={radioClassNames}
            >
                {regulatedContent}
            </RadioInput>
            <RadioInput
                reason="reason_explicit"
                containerClassNames={radioClassNames}
            >
                {explicitContent}
            </RadioInput>
            <RadioInput
                reason="reason_hateful"
                containerClassNames={radioClassNames}
            >
                {hatefulContent}
            </RadioInput>
            <RadioInput
                reason="reason_extremism"
                containerClassNames={radioClassNames}
            >
                {violenceExtremism}
            </RadioInput>
            <RadioInput
                reason="reason_copyright_infringement"
                containerClassNames={radioClassNames}
            >
                {copyrightInfringement}
            </RadioInput>
            {radioInputRender}
        </div>
    );
};
